import React, { Component } from 'react';
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';
import Master from './components/master';
import Home from './pages/home';
import Sobre from './pages/about';
import Contato from './pages/contact';


var Erro404 = () => (<h2 className="limite secao">Página não encontrada</h2>);

//location.pathname
var path =   window.location.pathname.indexOf("/site2/build/") >= 0 ? "/site2/build/" : "/"


class Routes extends Component {
    render() {
        return (
            <BrowserRouter>
                <Master >
                    <Switch>
                        <Route exact path={path} component={Home} />
                        <Route path={path + "contact"} component={Contato} />
                        <Route path={path + "about"} component={Sobre} />
                        <Route component={Erro404} />
                    </Switch>
                </Master>
            </BrowserRouter>
        );
    }
};


export default Routes;



// WEBPACK FOOTER //
// ./src/js/routes.js